export default __webpack_public_path__ + "static/media/hero-bottom.c2569e7c.svg";